import React from 'react';

const IconStraighten = (): React.ReactElement => (
    <i id="iconStraighten" className="material-symbols-outlined icon-rotated">
        straighten
    </i>
);

export default IconStraighten;
